// extracted by mini-css-extract-plugin
export var locationCard = "_f7-0";